/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowURightUp(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M223.39062,83.06152A8,8,0,0,1,216,88H176v80a64,64,0,0,1-128,0V80a8,8,0,0,1,16,0v88a48,48,0,0,0,96,0V88H120a8.00037,8.00037,0,0,1-5.65723-13.65674l48-48a8.00034,8.00034,0,0,1,11.31446,0l48,48A7.99931,7.99931,0,0,1,223.39062,83.06152Z" />
    </Svg>
  );
}

export default ArrowURightUp;
